import { LoadingSpinner } from "./LoadingSpinner";

export interface ISpinnerProps {
  customStyle?: React.CSSProperties;
}

export default LoadingSpinner;
